import posthog from "posthog-js";

declare global {
  interface Window {
    _paq?: Array<[string, ...unknown[]]>;
  }
}

type AnalyticsValue = string | number | boolean | null | undefined;

type PortfolioPricingEventProps = Record<string, AnalyticsValue>;

const toCountRange = (value: string | number | null | undefined) => {
  const numericValue =
    typeof value === "number"
      ? value
      : typeof value === "string" && value.trim().length > 0
        ? Number(value)
        : NaN;

  if (!Number.isFinite(numericValue) || numericValue <= 0) {
    return undefined;
  }
  if (numericValue <= 3) return "1-3";
  if (numericValue <= 10) return "4-10";
  if (numericValue <= 25) return "11-25";
  if (numericValue <= 50) return "26-50";
  if (numericValue <= 100) return "51-100";
  return "101+";
};

export const buildPortfolioPricingAnalyticsProps = (input?: {
  approximatePortfolioSize?: string | null;
  currentSiteCount?: string | number | null;
  expectedSiteCount?: string | number | null;
  submissionSource?: string | null;
  status?: string | null;
  accountKind?: string | null;
  campaignSource?: string | null;
}) => ({
  submission_source: input?.submissionSource ?? undefined,
  status: input?.status ?? undefined,
  account_kind: input?.accountKind ?? undefined,
  campaign_source: input?.campaignSource ?? undefined,
  portfolio_size_range: input?.approximatePortfolioSize ?? undefined,
  current_site_count_range: toCountRange(input?.currentSiteCount),
  expected_site_count_range: toCountRange(input?.expectedSiteCount),
});

export const capturePortfolioPricingEvent = (
  eventName: string,
  properties: PortfolioPricingEventProps = {},
) => {
  try {
    posthog.capture(eventName, properties);
  } catch (error) {
    console.debug("Portfolio pricing capture skipped", error);
  }

  try {
    if (typeof window === "undefined" || !Array.isArray(window._paq)) {
      return;
    }
    window._paq.push(["trackEvent", "Portfolio Pricing", eventName]);
  } catch (error) {
    console.debug("Portfolio pricing Matomo capture skipped", error);
  }
};
